import { render, staticRenderFns } from "./activitys.vue?vue&type=template&id=c13c7878&scoped=true"
import script from "./activitys.vue?vue&type=script&lang=js"
export * from "./activitys.vue?vue&type=script&lang=js"
import style0 from "./activitys.vue?vue&type=style&index=0&id=c13c7878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13c7878",
  null
  
)

export default component.exports